window.$ = require('jquery');
window.jQuery = window.$;

require('jquery-validation');

var phoneIsValid = require('./phone-validator');
$.validator.addMethod("usPhone", function (value, element) {
    return phoneIsValid(value);
}, "Please enter only digits, dash and comma");

require('bootstrap');
require('bootstrap/dist/css/bootstrap.css');
require('bootstrap/dist/css/bootstrap-theme.css');

require('../css/text-styles.scss');
require('../css/offsets.scss');
require('../css/video-scroller.css');
require('../css/mobile-styles.scss');
require('../css/sticky-footer.scss');

require('../css/page-replay.scss');
require('../css/page-checkout.scss');

require('../css/section-testimonials.scss');

require("font-awesome/package.json");
require('style-loader!css-loader!less-loader!../css/font-awesome.less');

require('./video-scroller.js');
require('./ios-fix.js');

window.exitpopup = require('./exitpopup.js');
require('../css/exitpopup.css');
require('../css/exitpopup-box.css');



//require('./framebox.js');


var Clever = {};
Clever.checkoutPage = require('./page-checkout');
window.Clever = Clever;
